import { IconName } from '@fortawesome/fontawesome-svg-core';
import { SelectOption } from '@y42/util/select-option';
import { BorderPositionEnum, WordBreakEnum } from './datos-axis.model';

export type StyleOption<T> = SelectOption<T> & { icon: IconName };
export const BorderPositionOptions: Array<StyleOption<BorderPositionEnum>> = [
  {
    label: 'Border All',
    icon: 'border-all',
    value: BorderPositionEnum.fullBorder,
  },
  {
    label: 'Inner Border',
    icon: 'border-inner',
    value: BorderPositionEnum.inside,
  },
  {
    label: 'Border Center Vertical',
    icon: 'border-center-v',
    value: BorderPositionEnum.verticalBorder,
  },
  {
    label: 'Border Center Horizontal',
    icon: 'border-center-h',
    value: BorderPositionEnum.horizontalBorder,
  },
  {
    label: 'Outer Border',
    icon: 'border-outer',
    value: BorderPositionEnum.border,
  },
  {
    label: 'Border Left',
    icon: 'border-left',
    value: BorderPositionEnum.leftBorder,
  },
  {
    label: 'Border Top',
    icon: 'border-top',
    value: BorderPositionEnum.topBorder,
  },
  {
    label: 'Border Right',
    icon: 'border-right',
    value: BorderPositionEnum.rightBorder,
  },
  {
    label: 'Border Bottom',
    icon: 'border-bottom',
    value: BorderPositionEnum.bottomBorder,
  },
  {
    label: 'None Border',
    icon: 'border-none',
    value: BorderPositionEnum.noneBorder,
  },
];

export const CellBorderPositionOptions: Array<SelectOption<BorderPositionEnum> & { icon: IconName }> = [
  {
    label: 'Outer Border',
    icon: 'border-outer',
    value: BorderPositionEnum.border,
  },
  {
    label: 'Border Left',
    icon: 'border-left',
    value: BorderPositionEnum.leftBorder,
  },
  {
    label: 'Border Top',
    icon: 'border-top',
    value: BorderPositionEnum.topBorder,
  },
  {
    label: 'Border Right',
    icon: 'border-right',
    value: BorderPositionEnum.rightBorder,
  },
  {
    label: 'Border Bottom',
    icon: 'border-bottom',
    value: BorderPositionEnum.bottomBorder,
  },
  {
    label: 'None Border',
    icon: 'border-none',
    value: BorderPositionEnum.noneBorder,
  },
];

export const WordBreakOptions: Array<SelectOption<WordBreakEnum> & { icon: string }> = [
  {
    label: 'Normal',
    icon: 'assets/images/axis-style-icons/text-style/breaking-word/normal.svg',
    value: WordBreakEnum.normal,
  },
  {
    label: 'Break All',
    icon: 'assets/images/axis-style-icons/text-style/breaking-word/break-all.svg',
    value: WordBreakEnum.breakAll,
  },
  {
    label: 'Keep All',
    icon: 'assets/images/axis-style-icons/text-style/breaking-word/keep-all.svg',
    value: WordBreakEnum.keepAll,
  },
];
